export class ApiError extends Error {
  code?: number
  status?: number
  details?: unknown

  constructor(message: string, options: { code?: number; status?: number; details?: unknown } = {}) {
    super(message)
    this.name = 'ApiError'
    this.code = options.code
    this.status = options.status
    this.details = options.details
  }
}
